/**
 * Create a cohesive and consistent relationship
 * between a parent template and it's expected partials
 * 
 * @class  ViewRender
 * 
 * @example
 *    new ViewRender("stuff {{> partialView}}", {
 *        partialView : "and {{something}}"
 *    });
 *    ViewRender.render({ something : "things"}); ->
 *        "stuff and things"
 */
define('responsive-gameday/views/render/ViewRender',['require','exports','module','es6ish-class/es6ish-class','jquery'],function(require,exports,module){
    var classifier = require('es6ish-class/es6ish-class'),
        $ = require( 'jquery' );

    function emptyView(data){
        return "";
    }

    /**
     * ViewRender constructor
     * @param {function} main    Primary (parent) template
     * @param {object}  partials Hash of template partials as referenced in main
     *
     */
    function ViewRender(main,partials) {

        this.viewState = {};
        this.main = main;
        this.partials=$.extend({},partials||{});
    }

    ViewRender.prototype = {
        /**
         * Render a full view based on the context data and return the string.
         * @param  {object} context context data used for evaluating the template.
         * @return {string}         String of the rendered template.
         */
        render : function(context){
            var viewContext = this.viewContext(context);
            return this.main(viewContext,this.partials);
        },
        /**
         * Target a specific view partial to be rendered.
         * @param  {string} id      View partial id as set via the constructor.
         * @param  {object} context context data used for evaluating the view partial.
         * @return {string}         String of the rendered template.
         */
        renderPartial : function(id,context){
            var view=this.partials[id]||emptyView,
                viewContext = this.viewContext(context);

            return view(viewContext,this.partials);
        },
        /**
         * Storage point for a view's state (none data related) info (active tab, 
         * form input selection states, etc).  
         *     
         * @param {object} stateInfo Collection of state keys/values.
         */
        setViewState : function(stateInfo){
            this.viewState=$.extend(this.viewState,stateInfo);
        },

        viewContext : function(context){
            var viewContext = Object.create(context);
            viewContext.viewState = this.viewState;
            return viewContext;
        },

        // Someday, you will be awesome
        bindToView : function(){

        }

    };
    return classifier(ViewRender);
});
